import styled from 'styled-components';
export var HiddenText = styled.span.withConfig({
  displayName: "HiddenText",
  componentId: "sc-1ifpuuw-0"
})(["display:none;"]);